import React from 'react';
import styles from './FormRegisterOne.module.scss';
import ManagementCompanyForm from '../ManagementCompanyForm/ManagementCompanyForm';
import HousesForm from '../HousesForm/HousesForm';
import SelectedAddressesForm from '../SelectedAddressesForm/SelectedAddressesForm';

const FormRegisterOne = () => {
  return (
    <div className={styles.conteiner}>
      <ManagementCompanyForm />
      <HousesForm />
      <SelectedAddressesForm />
    </div>
  );
};

export default FormRegisterOne;
